import React from 'react';
import { useInView } from 'react-intersection-observer';

const ScrollAnimation = ({ 
  children, 
  animation = 'fade-in-view', 
  delay = 0,
  threshold = 0.1 
}) => {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce: true
  });

  return (
    <div 
      ref={ref} 
      className={`${animation} ${inView ? 'in-view' : ''}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default ScrollAnimation;
